<wr-new-data-table headerText="Konzern-Verwaltung"
                   localStorageIdentifier="corporate-group-overview"
                   [loadItemsFunction]="loadGroups"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateTo($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canManage()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template dataColumn let-group key="name" display="Name">
    {{ group.name }}
  </ng-template>
</wr-new-data-table>
